const ROOT_METADATA_NODE_ID = '-1'

export default ROOT_METADATA_NODE_ID
